import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, model, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from "@ngx-formly/core";
import { AccordionModule } from "primeng/accordion";

@Component({
  selector: 'app-accordion-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    AccordionModule
  ],
  templateUrl: './accordion-wrapper.component.html',
  styleUrl: './accordion-wrapper.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild('fieldComponent', { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;

  /** Matches the single panel `value` (0). `undefined` = all closed. */
  selectedValue = model<number | undefined>(0);

  ngOnInit(): void {
    this.selectedValue.set(this.initialAccordionValue());
  }

  private initialAccordionValue(): number | undefined {
    const attrs = this.props?.attributes as { activeIndex?: unknown; isOpen?: unknown } | undefined;
    if (!attrs) {
      return 0;
    }
    if (attrs.isOpen === false) {
      return undefined;
    }
    const activeIndex = attrs.activeIndex;
    if (activeIndex === null || activeIndex === -1) {
      return undefined;
    }
    if (typeof activeIndex === "number" && Number.isFinite(activeIndex)) {
      return activeIndex;
    }
    if (typeof activeIndex === "string" && activeIndex !== "") {
      const parsed = Number(activeIndex);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    const isOpen = attrs.isOpen;
    if (typeof isOpen === "number" && Number.isFinite(isOpen)) {
      return isOpen;
    }
    return 0;
  }
}
